<template>
  <div class="paymentform" v-loading="paymentLoading">
    <div class="panelheader border-blue">
      <div class="booker-title">Payment</div>
    </div>

    <div class="body">

      <el-row class="payment-form-header">
        <el-col span="12" offset="6">
          Choose a payment option below and fill out the appropriate information.
        </el-col>
      </el-row>

      <el-row gutter="30">
        <el-col span="12">
          <div class="payment-option cc selected" @click="onUseCC">
            <i class="el-icon-fa-credit-card"></i>
            <div>Credit Card</div>
          </div>
        </el-col>

        <el-col span="12">
          <div class="payment-option pp" @click="onUsePP">
            <i class="el-icon-fa-paypal"></i>
            <div>PayPal</div>
          </div>
        </el-col>
      </el-row>

      <el-row>
        <el-col :sm="{span:16, offset:4}" :xs="{span:22, offset:1}">

          <el-form :model="paymentData" :rules="validators" ref="paymentData" label-width="120px" label-position="top" class="payment-form">
            <el-form-item label="FULL NAME" class="payment-form-item">
              <el-input v-model="paymentData.name"></el-input>
            </el-form-item>

            <el-form-item label="CONTACT NUMBER" class="payment-form-item">
              <el-input v-model="paymentData.number"></el-input>
            </el-form-item>

            <el-form-item label="STREET ADDRESS" class="payment-form-item">
              <el-input v-model="paymentData.address"></el-input>
            </el-form-item>

            <el-form-item label="CITY" class="payment-form-item">
              <el-input v-model="paymentData.city"></el-input>
            </el-form-item>

            <el-row gutter="10">
              <el-col span="12">
                <el-form-item label="POST CODE" class="payment-form-item">
                  <el-input v-model="paymentData.postcode"></el-input>
                </el-form-item>
              </el-col>

              <el-col span="12">
                <el-form-item label="STATE" class="payment-form-item">
                  <el-select v-model="paymentData.state">
                    <el-option v-for="state in states" 
                      :key="state.name"
                      :value="state.name">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>


            <div v-if="useCC">
              
              <el-form-item label="CARD" class="payment-form-item" v-if="(this.customer && this.paymentSources.length > 0)">
                <el-select v-model="paymentData.card">
                  <el-option v-for="card in paymentSources"
                    :key="card.id"
                    :value="card.id"
                    :label="formatCardLabel(card)">
                    <template v-if="card.brand">
                      <i :class="'el-icon-fa-cc-'+card.brand.toLowerCase()" aria-hidden="true"></i>
                      Card ending in {{ card.last4 }}
                    </template>
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item 
                label="CARD DETAILS" 
                class="payment-form-item" 
                v-if="paymentData.newCC"
                v-loading="cardLoading"
                element-loading-text="Securing input...">
                <div id="card-element" class="field"></div>
              </el-form-item>

            </div>
            <div v-else>

              <el-form-item label="" class="payment-form-item">
                <paypal
                 @confirm="paypalConfirm">
                </paypal>
                <!-- <paypal
                  amount="20.00"
                  currency="AUD"
                  :client="paypalCreds"
                  invoiceNumber="201709280000">
                </paypal> -->
              </el-form-item>

            </div>
          </el-form>
        </el-col>
      </el-row>

      <div class="payment-form-buttons">
        <el-button type="add" @click="onConfirm" :disabled="disableConfirm">Confirm Payment</el-button>
        <el-button type="cancel" @click="onCancel">Cancel</el-button>
      </div>

    </div>
  </div>
</template>


<script>

import PayPal from './PayPalCheckout';
import requests from '../../requests';
import auth from '../../auth';

export default {
  name: 'paymentform',
  props: ['customer'],
  data(){
    return {
      states: [
        {name: 'QLD'},
        {name: 'NSW'},
        {name: 'VIC'},
        {name: 'ACT'},        
        {name: 'TAS'},
        {name: 'NT'},
        {name: 'SA'},
        {name: 'WA'},
      ],
      validators: {
        name: [ 
          { required: true, message: "Please input a name.", trigger: 'blur' } 
        ],
        address: [ 
          { required: true, message: "Please input an address.", trigger: 'blur' } 
        ],
        postcode: [
          { required: true, message: "Please input a post code.", trigger: 'blur' } 
        ],
        state: [ { 
          required: true, message: "Please select a state.", trigger: 'blur' } 
        ],
        card: [ { 
          required: true, message: "Please select a card.", trigger: 'blur' }
        ],
      },
      useCC: true,
      paymentData: {
        name:'',
        number: '',
        address: '',
        city: '',
        postcode: '',
        state: '',
        card: '',
        token: '',
        newCC: true,
      },
      startingpd: {},
      cardCompleted: false,
      stripeOpts: {
        key: 'pk_test_hqJyOUMwO50iYpDJIfxrgjL5',
        image: 'https://stripe.com/img/documentation/checkout/marketplace.png',
        locale: 'auto',
        token:'',
        email:'',
      },
      stripe: null,
      elements: null,
      card: null,
      paymentLoading: false,
      paymentSources: [],
      cardLoading: false,
      disableConfirm: true,
    }
  },
  beforeMount(){

    //If Stripe hasn't loaded yet, recheck every 1.5secs
    if(!window.Stripe){
      var c = 0;
      var interval = setInterval(()=>{
        if(c < 8 ) {
          if(window.Stripe) {
            this.configureStripe();
            clearInterval(interval);
            
            if(!this.customer) {
              this.mountCard();
            }
          }
          c++;
        } else {
          clearInterval(interval);
        }
      }, 1500); 
    }

    var context = this;
    var profile = auth.getProfile();

    requests.getUserContact(this, function(result){
      console.log('get contact:', result)
      if(result.action === 'success') {
        Object.assign(context.paymentData, result.data);
      }
      context.startingpd = Object.assign({}, context.paymentData);
    });
  },

  mounted() {
    this.configureSources();
    console.log(this.paymentData.card)
    this.configureStripe();

    if(this.paymentData.newCC){
      this.mountCard();
    }
  },
  updated() {
    if(this.paymentData.newCC) {
      if(!this.stripe || !this.elements || !this.card) {
        this.configureStripe();
      } else {
        this.mountCard();
      }
    }

  },
  beforeDestroy(){
    if(this.card) {
      this.card.off('ready', this.onCardMounted);
      this.card.off('change', this.onCardChange);
      this.card.unmount();
      this.card = '';
    }
    this.paymentData.card = null;
  },
  methods: {
    onUseCC(){
      $('.cc').removeClass('selected');
      $('.pp').removeClass('selected');
      $('.cc').addClass('selected');
      this.useCC = true;
    },
    onUsePP(){
      $('.pp').removeClass('selected');
      $('.cc').removeClass('selected');
      $('.pp').addClass('selected');
      this.useCC = false;
    },
    configureSources() {
      if(this.customer) {
        this.paymentSources = this.customer.sources.data;
        console.log(this.paymentSources);
        if(this.paymentSources[0].id !== '-1') {
          this.paymentSources.unshift({id:'-1', last4: '0000'})
        }
      }
  
      if(!this.customer || this.paymentSources.length === 0) {
        this.paymentData.newCC = true;
      } else if (this.paymentData.card !== '-1'){
        this.paymentData.newCC = false;
      }
    },
    configureStripe() {
      if(!window.Stripe) {
        return;
      }
      this.stripe = Stripe(this.stripeOpts.key);
      this.elements = this.stripe.elements({});
      this.card = this.elements.create('card', {
        hidePostalCode: true,
        style: {
          base: {
            lineHeight: '36px',
          }
        }
      });        
    },
    mountCard(){
      var ce = $('#card-element');
      if(ce.length > 0 && ce[0].childElementCount === 0) {
        this.cardLoading = true;
        this.card.off('ready').on('ready', this.onCardMounted);
        this.card.off('change').on('change', this.onCardChange);
        this.card.mount('#card-element');
      }
    },
    onCardMounted(){
      this.cardLoading = false;
      this.cardCompleted = false;
    },
    onCardChange(event){
      if(event.complete){
        this.paymentData.card = '-1'
        this.cardCompleted = true;
      } else {
        this.cardCompleted = false;
      }
      console.log(this.cardCompleted, event);
    },
    makeStripeData(){
      return {
        'name': this.paymentData.name,
        'address_line1': this.paymentData.address,
        'address_city': this.paymentData.city,
        'address_state': this.paymentData.state,
        'address_zip': this.paymentData.postcode,
        'address_country': 'AU'
      }
    },
    formatCardLabel(card) {
      if(card.id === '-1') {
        return "New Card"
      } else {
        return "Card ending in " + card.last4
      }
    },
    validateData(){
      var invalids = [];

      for (var key in this.paymentData) {
        if (this.paymentData.hasOwnProperty(key)) {
          var value = this.paymentData[key];
          if(key != 'token' && !value) {
            invalids.push(key);
          }
        }
      }
      return invalids;
    },
    onConfirm() {

      var invalids = this.validateData();
      if(invalids.length > 0){
        if( !(invalids.length === 1 && invalids[0] === 'newCC')) {
          return;
        }
      }

      var cardData = this.makeStripeData();
      this.paymentLoading = true;

      if(this.paymentData.card === '-1') {

        this.stripe.createToken(this.card, cardData).then((result) => {
          this.paymentLoading = false;
          console.log(this.card, cardData, result);
          if(!result.error) {
            this.paymentData.token = result.token;
            this.$emit('confirm', this.paymentData, true);          
          } else {
            this.$message({
              type: 'error',
              message: 'Payment error: ' +  result.error.message
            })
          }
        });
      
      } else {
        setTimeout(()=>{
          this.paymentLoading = false;
          this.$emit('confirm', this.paymentData, true);
        }, 1300);
      }

      //
      var pdcopy = Object.assign({}, this.paymentData);
      pdcopy.card=''; pdcopy.token=''; pdcopy.newCC=true;
      if(JSON.stringify(pdcopy) !== JSON.stringify(this.startingpd)) {
        requests.updateUserContact(this, pdcopy, function (result) {
          console.log('update contact:', result);
        });
      }

    },
    onCancel() {
      this.$emit('cancel');
    },
    paypalConfirm(payment){
      this.$emit('confirm', payment, false);
    }
  },
  watch: {
    'paymentData.card': function(newVal) {
      this.paymentData.newCC = (newVal === '-1')
    },
    'paymentData.newCC': function(newVal) {
      if(newVal) {
        this.mountCard();
      }
    },
    'customer': function(newVal) {
      if(newVal) {
        this.paymentSources = [];
        this.newCC = false;
        this.configureSources();
      } else {
        this.configureStripe();
      }
    },
    paymentData: {
      handler(newVal){
        var invalids = this.validateData();
        if(invalids.length > 0) {
          this.disableConfirm = !( invalids.length === 1 && invalids[0] === 'newCC')
        } else {
          this.disableConfirm = !this.cardCompleted;
        }
      },
      deep: true,
    },
    cardCompleted: function(newVal){
      this.disableConfirm = !(newVal && this.validateData().length === 0)
    }
  },
  components: {
    'paypal': PayPal
  }
}
</script>


<style>

  .payment-form-item {
    text-align: left;
  }

  .payment-form-item > label {
    font-weight: bold;    
  }

  .payment-form-item .el-date-editor {
    width: 100%;
  }

  .ccIcon {
    padding-right: 20px;
  }

  .cvv i {
    border-left: 1px solid #BFCBD9;
    border-radius: 2px;
  }

  .payment-form {
    margin-top: 30px;
  }

  .payment-option {
    width: 50%;
    height: 120px;
    background: #F3F3F5;
    border: 1px solid transparent;
    border-radius: 5px;
    cursor: pointer;
    
    font-weight: bold;
    color: #4A4A4A;
    margin: 16px auto;
  }

  .payment-option:hover, .payment-option:focus, .payment-option.selected {
    color: #33B0AE;
    border: 1px solid #33B0AE;
    background: none;
  }

  .payment-option i {
    font-size: 250% !important;
    margin: 15%;
  }

  .payment-option.cc {
    float: right;
  }

  .payment-option.pp {
    float: left;
  }

  .payment-form-header {
    font-size: 120%;
    color: #C9C9C9;
  }

  .payment-form-buttons {
    text-align: left;
    margin-top: 30px;
  }

  .field {
    background: white;
    box-sizing: border-box;
    font-weight: 400;
    border: 1px solid #CFD7DF;
    border-radius: 6px;
    color: #32315E;
    outline: none;
    flex: 1;
    height: 36px;
    line-height: 36px;
    padding: 0 20px;
    cursor: text;
  }

</style>



// WEBPACK FOOTER //
// PaymentForm.vue?eafd3e2e